import { createAction, props } from '@ngrx/store';

export const EventEmptyAction = createAction(
  '[Event] Empty Action',
  props<any>()
);

export const EventRedirectToListAction = createAction(
  '[Event] Empty Redirect to List Action',
  props<any>()
);

export const clearSelectedEvent = createAction(
  '[Event] Clear Selected Event Action',
  props<any>()
);

export const updateEventListSwitcher = createAction(
  '[Event] Update EventList Switcher',
  props<any>()
);

export const loadEventList = createAction(
  '[Event] Load EventList',
  props<any>()
);

export const loadEventListSuccess = createAction(
  '[Event] Load EventList Success',
  props<{ data: any }>()
);

export const loadEventListFailure = createAction(
  '[Event] Load EventList Failure',
  props<{ error: any }>()
);

export const loadEventListAndSelect = createAction(
  '[Event] Load EventList and Select',
  props<any>()
);

export const loadEventListAndSelectSuccess = createAction(
  '[Event] Load EventList and Select Success',
  props<{ data: any }>()
);

export const loadEventListAndSelectFailure = createAction(
  '[Event] Load EventList and Select Failure',
  props<{ error: any }>()
);

export const createEvent = createAction(
  '[Event] Create Event',
  props<any>()
);

export const createEventSuccess = createAction(
  '[Event] Create Event Success',
  props<any>()
);

export const createEventFailure = createAction(
  '[Event] Create Event Failure',
  props<any>()
);

export const createVEvent = createAction(
  '[VEvent] Create VEvent'
);

export const createVEventSuccess = createAction(
  '[VEvent] Create VEvent Success',
  props<any>()
);

export const createVEventFailure = createAction(
  '[VEvent] Create VEvent Failure',
  props<{ error: any }>()
);

export const createHEvent = createAction(
  '[Event] Create HEvent',
  props<any>()
);

export const createHEventSuccess = createAction(
  '[Event] Create HEvent Success',
  props<any>()
);

export const createHEventFailure = createAction(
  '[Event] Create HEvent Failure',
  props<any>()
);

export const putEvent = createAction(
  '[Event] Put Event',
  props<any>()
);

export const putEventSuccess = createAction(
  '[Event] Put Event Success',
  props<any>()
);

export const putEventFailure = createAction(
  '[Event] Put Event Failure',
  props<any>()
);

export const putVEvent = createAction(
  '[Event] Put Virtual Event',
  props<any>()
);

export const putVEventSuccess = createAction(
  '[Event] Put Virtual Event Success',
  props<any>()
);

export const putVEventFailure = createAction(
  '[Event] Put Virtual Event Failure',
  props<any>()
);

export const putHEvent = createAction(
  '[Event] Put Hybrid Event',
  props<any>()
);

export const putHEventSuccess = createAction(
  '[Event] Put Hybrid Event Success',
  props<any>()
);

export const putHEventFailure = createAction(
  '[Event] Put Hybrid Event Failure',
  props<any>()
);

export const deleteEvent = createAction(
  '[Event] Delete Event',
  props<any>()
);

export const deleteEventSuccess = createAction(
  '[Event] Delete Event Success',
  props<any>()
);

export const deleteEventFailure = createAction(
  '[Event] Delete Event Failure',
  props<any>()
);

export const deleteVEvent = createAction(
  '[Event] Delete Virtual Event',
  props<any>()
);

export const deleteVEventSuccess = createAction(
  '[Event] Delete Virtual Event Success',
  props<any>()
);

export const deleteVEventFailure = createAction(
  '[Event] Delete Virtual Event Failure',
  props<any>()
);

export const deleteHEvent = createAction(
  '[Event] Delete Hibryd Event',
  props<any>()
);

export const deleteHEventSuccess = createAction(
  '[Event] Delete Hibryd Event Success',
  props<any>()
);

export const deleteHEventFailure = createAction(
  '[Event] Delete Hibryd Event Failure',
  props<any>()
);

export const resetVEvent = createAction(
  '[Event] Reset Virtual Event',
  props<any>()
);

export const resetVEventSuccess = createAction(
  '[Event] Reset Virtual Event Success',
  props<any>()
);

export const resetVEventFailure = createAction(
  '[Event] Reset Virtual Event Failure',
  props<any>()
);

export const selectEvent = createAction(
  '[Event] Select Event',
  props<any>()
);

export const loadEventConfig = createAction(
  '[Event] Load EventConfig',
  props<any>()
);

export const loadEventConfigSuccess = createAction(
  '[Event] Load EventConfig Success',
  props<{ data: any }>()
);

export const loadEventConfigFailure = createAction(
  '[Event] Load EventConfig Failure',
  props<{ error: any }>()
);

export const addEventPageBlock = createAction(
  '[Event] Add Event Page Block',
  props<any>()
);

export const addEventPageBlockSuccess = createAction(
  '[Event] Add Event Page Block Success',
  props<{ data: any }>()
);

export const addEventPageBlockFailure = createAction(
  '[Event] Add Event Page Block Failure',
  props<{ error: any }>()
);


export const updateEventPageBlock = createAction(
  '[Event] Update Event Page Block',
  props<any>()
);

export const updateEventPageBlockSuccess = createAction(
  '[Event] Update Event Page Block Success',
  props<{ data: any }>()
);

export const updateEventPageBlockFailure = createAction(
  '[Event] Update Event Page Block Failure',
  props<{ error: any }>()
);


export const removeEventPageBlock = createAction(
  '[Event] Remove Event Page Block',
  props<any>()
);

export const removeEventPageBlockSuccess = createAction(
  '[Event] Remove Event Page Block Success',
  props<{ data: any }>()
);

export const removeEventPageBlockFailure = createAction(
  '[Event] Remove Event Page Block Failure',
  props<{ error: any }>()
);


export const updateEventConfigPage = createAction(
  '[Event] Update Event Config Page',
  props<any>()
);

export const updateEventConfigPageSuccess = createAction(
  '[Event] Update Event Config Page Success',
  props<{ data: any }>()
);

export const updateEventConfigPageFailure = createAction(
  '[Event] Update Event Config Page Failure',
  props<{ error: any }>()
);

export const addToCart = createAction(
  '[Event] Add Donation to Cart',
  props<any>()
);

export const addToCartSuccess = createAction(
  '[Event] Add Donation to Cart Success',
  props<{ data: any }>()
);

export const addToCartFailure = createAction(
  '[Event] Add Donation to Cart Failure',
  props<{ error: any }>()
);

export const addRegistration = createAction(
  '[Event] Add Event Page Registration',
  props<any>()
);

export const addRegistrationSuccess = createAction(
  '[Event] Add Event Page Registration Success',
  props<{ data: any }>()
);

export const addRegistrationFailure = createAction(
  '[Event] Add Event Page Registration Failure',
  props<{ error: any }>()
);


export const updateRegistration = createAction(
  '[Event] Update Event Page Registration',
  props<any>()
);

export const updateRegistrationSuccess = createAction(
  '[Event] Update Event Page Registration Success',
  props<{ data: any }>()
);

export const updateRegistrationFailure = createAction(
  '[Event] Update Event Page Registration Failure',
  props<{ error: any }>()
);

export const removeRegistration = createAction(
  '[Event] Remove Event Page Registration',
  props<any>()
);

export const removeRegistrationSuccess = createAction(
  '[Event] Remove Event Page Registration Success',
  props<{ data: any }>()
);

export const removeRegistrationFailure = createAction(
  '[Event] Remove Event Page Registration Failure',
  props<{ error: any }>()
);

export const createStream = createAction(
  '[Event] Create Video Stream',
  props<any>()
);

export const createStreamSuccess = createAction(
  '[Event] Create Video Stream Success',
  props<any>()
);

export const createStreamFailure = createAction(
  '[Event] Create Video Stream Failure',
  props<any>()
);

export const loadAllStreams = createAction(
  '[Event] Load All Streams',
  props<any>()
);

export const loadAllStreamsSuccess = createAction(
  '[Event] Load All Streams Success',
  props<any>()
);

export const loadAllStreamsFailure = createAction(
  '[Event] Load All Streams Failure',
  props<any>()
);


export const loadVideoDownloadUrl = createAction(
  '[Event] Load Video Download Url',
  props<any>()
);

export const loadVideoDownloadUrlSuccess = createAction(
  '[Event] Load Video Download Url Success',
  props<any>()
);

export const loadVideoDownloadUrlFailure = createAction(
  '[Event] Load Video Download Url Failure',
  props<any>()
);
